/**
* Data transfer object for activities configuration
*/
export class ActivitiesConfigurationDTO {

  searchInterval: number;
  
}
